import { UserAddOutlined } from '@ant-design/icons';
import { type NodeProps } from '@xyflow/react';
import LeadUpdateMenu from 'automations/components/Nodes/LeadUpdateMenu/LeadUpdateMenu';
import { type LeadUpdateNodeType, nodeSchemas } from 'automations/types/nodeTypes';
import { getErrorList } from 'automations/utils/zod';
import { useMemo } from 'react';

import { type TriggerNodeReturnProps } from './useTriggerNodeConfig';

export default function useLeadUpdate(node: NodeProps<LeadUpdateNodeType>): TriggerNodeReturnProps {
  const errorMessages = useMemo(() => getErrorList(nodeSchemas.LeadUpdateNodeData, node.data), [node.data]);
  const AdditionalUI = useMemo(() => <LeadUpdateMenu node={node} />, [node]);

  return {
    icon: UserAddOutlined,
    hasErrors: errorMessages.length > 0,
    errorMessages,
    AdditionalUI,
  };
}
